import { Card, Form, Button, Input, Col, Checkbox, Divider, Row, Tooltip, Space } from 'antd';

import { useParams } from 'react-router-dom';
import { useCompanyData } from '../../../../../../Hooks/TT_ELD/Companies';
import { sendEvent } from '../../../../../../Utils/analytics';
import { companies } from '../../../../../../API/TT_ELD/Users/company';

type MyObjectType = {
  [key: string | number]: any;
};

type params = {
  readonly id: any;
};

const Integration = () => {
  const [form] = Form.useForm();
  const { id } = useParams<params>();

  const { data, isFetching, isLoading, refetch }: MyObjectType = useCompanyData(id);

  const normalizeValue = (v: any) => v || null;

  const onSubmit = async (values: any) => {
    values = {
      config: {
        ...values.config,
        eldType: normalizeValue(data?.config?.eldType),
        notificationEldDisconnect: data?.config?.notificationEldDisconnect,
        notificationEldDisconnectGlobal: data?.config?.notificationEldDisconnectGlobal,
        notificationEldFault: data?.config?.notificationEldFault,
        notificationEldFaultByCompany: data?.config?.notificationEldFaultByCompany,
        notificationWeighStation: data?.config?.notificationWeighStation,
      },
    };
    const body: MyObjectType = {};

    let key: string | number;
    let key2: string | number;
    for (key in values) {
      if (typeof data[key] === 'object' && !Array.isArray(data[key]) && data[key] != null) {
        for (key2 in values[key]) {
          if (
            typeof values[key][key2] === 'object' &&
            !Array.isArray(values[key][key2]) &&
            values[key][key2] != null
          ) {
            if (JSON.stringify(values[key][key2]) != JSON.stringify(data[key][key2])) {
              body[key] = values[key];
              break;
            }
          } else if (data[key][key2] != values[key][key2]) {
            body[key] = values[key];
            break;
          }
        }
      } else if (data[key] != values[key]) {
        body[key] = values[key];
      }
    }

    sendEvent(
      `Company page`,
      `Company  Tab Integration  `,
      `Company page Tab Integration Submit`,
      1,
    );
    companies.companyPatchData(body, id);
    refetch();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Card loading={isLoading || isFetching} style={{ width: '100%' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        name="basic"
        initialValues={{
          ...data,
        }}
      >
        <Row gutter={[12, 12]}>
          <Col xs={24} sm={24} md={12} lg={6}>
            <Form.Item
              name={['config', 'project44Id']}
              label="Project 44 ID"
              normalize={(value) => value?.trim()}
              rules={[
                {
                  required: true,
                  message: 'Project 44 ID is required',
                },
              ]}
            >
              <Input placeholder="Enter Project 44 ID" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Integration;
